import { makeStyles } from 'tss-react/mui';

const useStylesGridItemCardViewLine: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  gridItemCardViewLine: {
    minHeight: 40,
  },
  gridItemCardViewLineHeader: {
    marginRight: 5,
  },
  gridItemCardViewLineIcon: {
    height: 26,
    marginRight: 7,
  },
}));

export default useStylesGridItemCardViewLine;
